import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // Ensure we always reject with a valid error object
    console.error('Request interceptor error:', error);
    return Promise.reject(error || new Error('Request interceptor error'));
  }
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Ensure we always have a valid error object
    if (!error) {
      console.error('Response interceptor: null/undefined error');
      return Promise.reject(new Error('Network or response error'));
    }
    
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user');
      // Delay navigation to allow promises to settle
      setTimeout(() => {
        window.location.href = '/login';
      }, 100);
      // Return a more specific error instead of generic rejection
      return Promise.reject(new Error('Authentication required - redirecting to login'));
    }
    
    console.error('API Error:', {
      message: error.message,
      status: error.response?.status,
      url: error.config?.url
    });
    
    return Promise.reject(error);
  }
);

export default api;
